<template>
    <div>
        <b-card>
            <template slot="header" class="text-center">
                <b-row>
                    <b-col cols="12" sm="12" md="12" lg="12" xl="2">
                   <h3><b> Ticket Suministro</b></h3>
                    </b-col>
                </b-row>
            </template>
            <b-row>
                <b-col cols="1">
                    <b-button 
                        variant="primary"
                        @click="modalTicket"
                        >
                        Ticket
                    <i class="fa fa-plus" aria-hidden="true"></i>
                    </b-button>
                </b-col>
                <b-col cols="3">
                    <b-form-input 
                        placeholder="Buscar producto del Ticket" 
                        v-model="cadenabusqueda"
                         @keyup.enter="searchProduct()">
                    </b-form-input>
                </b-col>
                <b-col cols="7">
                  <b-button 
                    v-b-tooltip.hover.top="'Buscar'"
                    variant="primary"
                    @click="searchProduct()">
                    <i class="fa fa-search" aria-hidden="true"></i>
                  </b-button>
                </b-col>
                <b-col cols="1">
                    <b-button
                        class="ml-5"
                        v-b-tooltip.hover="'Actualizar Tabla'"
                        @click="listarTicket()">
                        <i class="fa fa-sync-alt"></i>
                    </b-button>
                </b-col>
                <b-modal v-model="verModalTicket" size="xl">
                    <template slot="modal-header">
                        <h3>Agregar Ticket</h3>
                    </template>
                    <b-row>
                       <b-col cols="12" sm="6"	md="4" lg="4" xl="2">
                        <b-select v-model="tipoDocumento">
                            <option 
                                :value="tipodocumento.tipo" 
                                v-for="tipodocumento in documentoIdentidad" 
                                v-bind:key="tipodocumento.tipo">
                                {{tipodocumento.nombre}}
                            </option>
                        </b-select>
                    </b-col>
                       <b-col cols="12" sm="6"	md="4" lg="4" xl="2">
                        <b-form-input
                            placeholder="Buscar..."
                            type="number"
                            v-model="numDocumento"
                            @input="getReceiversRemitente()">
                        </b-form-input>
                        <b-list-group v-if="listaRemitente" class="searcher-field">
                            <b-list-group-item 
                                v-for="(item, index) in listaRemitentes"
                                :key="index" @click="setReceiverRemitente(item)" 
                                class="searcher-result">
                                {{item.idReceptor + ' - ' + item.razonSocial}}
                            </b-list-group-item>
                        </b-list-group>
                    </b-col>
                        <b-col cols="12" sm="12" md="12" lg="12" xl="3">
                            <b-input-group>
                                <b-form-input
                                maxlength="8"
                                placeholder="Buscar Vehículo"
                                v-model="placa">
                                </b-form-input>
                                <b-input-group-text slot="append">
                                    <b-button
                                    v-b-tooltip.hover title="Clic para mostrar listado"
                                    @click="listaDeVehiculos()"
                                    variant="primary"
                                    class="pb-0 pt-0 pl-1 pr-1"
                                    size="sm">
                                    <i class="fa fa-search" aria-hidden="true"></i>
                                    </b-button>
                                    <template v-if="listaVehiculo">
                                        <b-button v-if="listaVehiculos.length > 0"
                                            v-b-tooltip.hover title="Cerrar Lista"
                                            variant="primary"
                                            size="sm"
                                            class="ml-1 pt-0 pb-0 pl-1 pr-1" 
                                            @click="closeListVehiculo()" >
                                            <i class="fas fa-arrow-up"></i>
                                        </b-button>
                                    </template>
                                </b-input-group-text>
                            </b-input-group>
                            <b-list-group v-if="listaVehiculo" class="searcher-fieldplaca">
                            <table v-if="listaVehiculos.length > 0" class="searcher-result3">
                                <tr class="centrarTitulo tablaborde">
                                <th style="width:15%;">Placa</th>
                                <!-- <th style="width:25%;">Código/Alias</th> -->
                                <th style="width:16%;">Ciruculación MTC</th>
                                <th style="width:10%;">Cod. Entidad</th>
                                <th style="width:16%;">Nro. Autorización</th>
                                </tr>
                            </table>
                            <template v-for="(item, index) in listaVehiculos">
                                <table  
                                    @click="setReceiverVehiculo(item)" 
                                    class="searcher-result2" 
                                    :key="index">  
                                    <tr>
                                    <td style="width:15%;" class="tablaborde centrarTitulo">{{item.placa}}</td>
                                    <!-- <td style="width:23%;" class="tablaborde ">{{item.codigo}}</td> -->
                                    <td style="width:16%;" class="tablaborde ">{{item.nroCirculacionMTC}}</td>
                                    <td style="width:10%; text-align:center" class="tablaborde ">{{item.idEntidad}}</td>
                                    <td style="width:16%;" class="tablaborde ">{{item.numeroPermiso}}</td>
                                    </tr>
                                </table>
                            </template>
                            </b-list-group> 
                        </b-col>
                        <b-col cols="12" sm="12" md="12" lg="12" xl="3">
                            <b-input-group>
                                <b-form-input
                                maxlength="8"
                                placeholder="Buscar Conductor"
                                v-model="nomConductor">
                                </b-form-input>
                                <b-input-group-text slot="append">
                                    <b-button
                                    v-b-tooltip.hover title="Clic para mostrar listado"
                                    @click="listarConductores()"
                                    variant="primary"
                                    class="pb-0 pt-0 pl-1 pr-1"
                                    size="sm">
                                    <i class="fa fa-search" aria-hidden="true"></i>
                                    </b-button>
                                    <template v-if="listaConductor">
                                        <b-button v-if="listaConductores.length > 0"
                                            v-b-tooltip.hover title="Cerrar Lista"
                                            variant="primary"
                                            size="sm"
                                            class="ml-1 pt-0 pb-0 pl-1 pr-1" 
                                            @click="closeListConductor()" >
                                            <i class="fas fa-arrow-up"></i>
                                        </b-button>
                                    </template>
                                </b-input-group-text>
                            </b-input-group>
                            <b-list-group v-if="listaConductor" class="searcher-fieldconductor">
                            <table v-if="listaConductores.length > 0" class="searcher-result3">
                                <tr class="centrarTitulo tablaborde">
                                <th style="width:20%;">Documento</th>
                                <th style="width:20%;">Alias</th>
                                <th style="width:20%;">Nombres</th>
                                <th style="width:20%;">Apellidos</th>
                                <th style="width:20%;">Nro. Licencia</th>
                                </tr>
                            </table>
                            <template v-for="(item, index) in listaConductores">
                            <table  
                                @click="setReceiverConductor(item)" 
                                class="searcher-result2" 
                                :key="index"> 
                                <tr>
                                <td style="width:20%;" class="tablaborde centrarTitulo">{{item.nroDocumento}}</td>
                                <td style="width:20%;" class="tablaborde centrarTitulo">{{item.codigo}}</td>
                                <td style="width:20%;" class="tablaborde centrarTitulo">{{item.nombres}}</td>
                                <td style="width:20%;" class="tablaborde centrarTitulo">{{item.apellidos}}</td>
                                <td style="width:20%;" class="tablaborde centrarTitulo">{{item.nroLicencia}}</td>
                                </tr>
                            </table>
                            </template>
                        </b-list-group>
                        </b-col>
                        <b-col cols="12" sm="12" md="12" lg="12" xl="2">
                            <datepicker
                                v-b-tooltip.hover.top="'Fecha Registro'"
                                placeholder="Fecha Registro"
                                v-model="fechaRegistro"
                                :bootstrap-styling="true"          
                                :language="es" 
                                :format="customFormatter">
                            </datepicker>
                        </b-col>
                    </b-row>
                    <br>
                    <b-row>
                        <b-col cols="12" sm="12" md="12" lg="12" xl="2">
                          <b-select v-model="serieInicial">
                            <option 
                                v-for="(serie, index) in listaSeries" 
                                :value="index" 
                                :key="index">
                                {{serie}}
                            </option>
                        </b-select>
                        </b-col>
                        <b-col cols="12" sm="12" md="12" lg="12" xl="2">
                           <b-form-select class="colorBorde" v-model="moneda">
                                <option :value="moneda" v-for="moneda in tipoMoneda" v-bind:key="moneda.id">
                                    {{ moneda.descripcion }}
                                </option>
                            </b-form-select>
                        </b-col>
                        <b-col cols="12" sm="12" md="12" lg="12" xl="8">
                            <b-input-group>
                             <b-form-input
                                placeholder="Descripcion Item"
                                maxlength="500"
                                v-model="descripcion"
                                @input="searchDescripcion()">
                            </b-form-input>
                            <b-input-group-text v-if="listades" slot="append">
                                <b-button 
                                    v-b-tooltip.hover title="Cerrar Lista"
                                    variant="primary"
                                    class="pb-0 pt-0 pl-1 pr-1"
                                    size="sm"
                                    @click="cerraListaProductos()">
                                    <i class="fas fa-arrow-up"></i>
                                </b-button>
                            </b-input-group-text>
                            </b-input-group>
                            <b-list-group v-if="listades" class="searcher-field">                            
                            <table v-if="listProductos.length > 0" class="searcher-result3">
                                <tr class="centrarTitulo tablaborde">
                                <th style="width:50%;">Productos</th>
                                <th style="width:10%;">Código</th>
                                <th style="width:10%;">Precio</th>
                                </tr>
                            </table>
                            <template v-for="(item, index) in listProductos">
                                <table  
                                    @click="setReceiverDescription(item)" 
                                    class="searcher-result2" 
                                    :key="index">  
                                    <tr>
                                    <td style="width:50%;" class="tablaborde ">{{item.descripcion.toUpperCase()}}</td>
                                    <td style="width:10%;" class="tablaborde centrarTitulo">{{item.codigo}}</td>
                                    <td style="width:10%;" class="tablaborde centrarTitulo">{{item.precioUnitario}}</td>
                                    </tr>
                                </table>
                            </template>
                        </b-list-group> 
                        </b-col>
                    </b-row>
                    <br>
                    <b-row>
                        <b-col cols="12" sm="12" md="12" lg="12" xl="2">
                            <b-form-input
                            type="number"
                            placeholder="Cantidad"
                            v-model="cantidadProducto">
                            </b-form-input>
                        </b-col>
                        <b-col cols="12" sm="12" md="12" lg="12" xl="2">
                            <b-form-input
                            type="number"
                            placeholder="Precio Unitario"
                            v-model="precioUnitario">
                            </b-form-input>
                        </b-col>
                        <b-col cols="12" sm="12" md="12" lg="12" xl="2">
                            <b-form-input
                            disabled
                            placeholder="Precio Total"
                            v-model="precioTotal">
                            </b-form-input>
                        </b-col>
                        <b-col cols="12" sm="12" md="12" lg="12" xl="6">
                            <b-form-input
                            placeholder="Observaciones"
                            v-model="observaciones">
                            </b-form-input>
                        </b-col>
                    </b-row>
                    <br>
                    <b-row>
                        <b-col  ols="12" sm="12" md="12" lg="12" xl="4">
                            <b-input-group>
                                <select class="custom-select mr-sm-2" v-model="formadepago">
                                    <option 
                                        :value="fpago"
                                        v-for="fpago in formaPago"
                                        v-bind:key="fpago.codigo"
                                        >{{ fpago.nombre }}
                                    </option>
                                </select>
                            </b-input-group>
                        </b-col>
                        <b-col cols="12" sm="12" md="12" lg="12" xl="4">
                           <b-button v-if="!botonEditar"
                           :disabled="validar()"
                           variant="primary"
                           style="width:100%"
                           @click="enviarTicket()">
                           Agregar Ticket
                           </b-button>
                           <b-button v-else
                           :disabled="validar()"
                           variant="warning"
                           style="width:100%"
                           @click="enviarEdicion()">
                           Editar Ticket
                           </b-button>
                        </b-col>
                    </b-row>
                </b-modal>
                </b-row>
                <!-- FIN MODAL -->
                <b-row>
                    <b-col>
                        <template v-if="mostrarTabla">
                            <div class="text-center mt-4">
                                <h2><i class="fa fa-spin fa-spinner"></i> Cargando...</h2>
                            </div>
                        </template>
                        <template v-else>
                              <b-table class="mt-4"
                                bordered
                                striped
                                outlined
                                responsive
                                small
                                :items="ticketsLista"
                                :fields="ticketsLista_lista">
                            <template v-if="row.item.nombreProducto !=null"  slot="nombreProducto" slot-scope="row">
                                {{row.item.nombreProducto.toUpperCase()}}
                            </template>
                            <template slot="serie" slot-scope="row">
                               <div class="text-center"> {{row.item.serieTicket}}-{{row.item.numeroTicket}}</div>
                            </template>
                            <template slot="placa" slot-scope="row">
                               <div class="text-center"> {{row.item.vehiculo.placa}}</div>
                            </template>
                            <template slot="cantidadProducto" slot-scope="row">
                               <div class="text-center"> {{row.item.cantidadProducto}}</div>
                            </template>
                             <template slot="precioUnitario" slot-scope="row">
                               <div class="text-center"> {{row.item.precioUnitario}}</div>
                            </template>
                             <template slot="PrecioTotal" slot-scope="row">
                               <div class="text-center"> {{row.item.PrecioTotal}}</div>
                            </template>
                            <template v-if="row.item.usuario !=null" slot="username" slot-scope="row">
                                {{row.item.usuario.username}}
                            </template>
                            <template v-if="row.item.observaciones !=null" slot="observaciones" slot-scope="row">
                                {{row.item.observaciones.toUpperCase()}}
                            </template>
                            <template slot="estado" slot-scope="row">
                               <template v-if="row.item.estado == 0">
                                <span class="badge badge-warning">
                                    Pendiente
                                    <i class="fa fa-spin fa-spinner"></i>
                                </span>
                               </template>
                               <template v-else>
                                <span class="badge badge-success">
                                    Enviado
                                    <i class="fa fa-spin fa-spinner"></i>
                                </span>
                               </template>
                            </template>
                            <template slot="acciones" slot-scope="row">
                                <b-button-group>
                                    <b-button
                                    size="sm"
                                    variant="primary"
                                    @click="row.toggleDetails" 
                                    v-b-tooltip.hover="'Ver más información'">
                                    <template v-if="!row.detailsShowing">
                                        <i class="fa fa-plus"></i> 
                                    </template>
                                    <template v-else>
                                        <i class="fa fa-minus"></i>
                                    </template>
                                    </b-button>
                                    <b-button @click="convertirCredito(row.item)"
                                        variant="success"
                                        title="Convertir a Crédito">
                                        <i class="fa fa-handshake text-white"></i>
                                    </b-button>
                                    <b-button 
                                    variant="dark" 
                                    size="sm" 
                                    @click="openModal(row.item)" 
                                    v-b-tooltip.hover="'Ticket Suministro'">
                                   <i class="fa fa-bookmark" aria-hidden="true"></i>
                                    </b-button>
                                    <b-button 
                                    size="sm"
                                    variant="warning"
                                    @click="editarTicket(row.item)"
                                     v-b-tooltip.hover="'Editar'">
                                    <i class="fa fa-edit"></i>
                                    </b-button>
                                    <b-button 
                                    size="sm"
                                    variant="danger"
                                    @click="eliminarTicket(row.item)"
                                     v-b-tooltip.hover title="Eliminar">
                                    <i class="fa fa-trash"></i>
                                    </b-button>
                                </b-button-group>
                            </template>
                            <template slot="row-details" slot-scope="row">
                                <b-row>
                                    <b-col cols="6">
                                        <b-card  border-variant="info" header-bg-variant="info">
                                            <template slot="header">
                                                <h5><b>Información Conductor</b></h5>
                                            </template>
                                            <b-row>
                                                <b-col cols="6">
                                                    <ul>
                                                        <li><b>Nombre:</b> {{row.item.conductor.nombres}}</li>
                                                        <li><b>Apellidos:</b> {{row.item.conductor.apellidos}}</li>
                                                        <li><b>Alias:</b> {{row.item.conductor.codigo}}</li>
                                                        <li><b>Documento:</b> {{row.item.conductor.nroDocumento}}</li>
                                                        <li><b>Fecha Nacimiento:</b> {{row.item.conductor.fechaNacimiento}}</li>
                                                        <li><b>Dirección:</b> {{row.item.conductor.direccion}}</li>
                                                        <li><b>Categoria Licencia:</b> {{row.item.conductor.catLicencia}}</li>
                                                    </ul>
                                                </b-col>
                                                <b-col cols="6">
                                                    <ul>
                                                        <li><b>Número Licencia:</b> {{row.item.conductor.nroLicencia}}</li>
                                                        <li><b>Observaciones:</b> {{row.item.conductor.observaciones}}</li>
                                                    </ul>
                                                </b-col>
                                            </b-row>
                                        </b-card>
                                    </b-col>
                                    <b-col cols="6">
                                        <b-card  border-variant="info" header-bg-variant="info">
                                            <template slot="header" >
                                                <h5><b>Información Vehículo</b></h5>
                                            </template>
                                            <b-row>
                                                <b-col cols="6">
                                                    <ul>
                                                        <li><b>Placa:</b> {{row.item.vehiculo.placa}}</li>
                                                        <li><b>Marca:</b> {{row.item.vehiculo.marca}}</li>
                                                        <li><b>Año Fabricación:</b> {{row.item.vehiculo.anioFabricacion}}</li>
                                                        <li><b>Propiedad:</b> {{row.item.vehiculo.propiedad}}</li>
                                                        <li><b>Tipo Vehículo:</b> {{row.item.vehiculo.tipoVehiculo}}</li>
                                                        <li><b>Cantidad Tripulación:</b> {{row.item.vehiculo.maximoTripulacion}}</li>
                                                        <li><b>Peso Bruto:</b> {{row.item.vehiculo.pesoBruto}}</li>
                                                    </ul>
                                                </b-col>
                                                <b-col cols="6">
                                                    <ul> 
                                                        <li><b>Carga Útil:</b> {{row.item.vehiculo.cargaUtil}}</li>
                                                        <li><b>Categoria MTC:</b> {{row.item.vehiculo.CategoriaMTC}}</li>
                                                        <li><b>Número Ciruculación MTC:</b> {{row.item.vehiculo.nroCirculacionMTC}}</li>
                                                        <li><b>Número Permiso:</b> {{row.item.vehiculo.numeroPermiso}}</li>
                                                        <li><b>Código:</b> {{row.item.vehiculo.codigo}}</li>
                                                        <li><b>Observaciones:</b> {{row.item.vehiculo.observaciones}}</li>
                                                    </ul>
                                                </b-col>
                                            </b-row>
                                        </b-card>
                                    </b-col>
                                </b-row>
                            </template>
                            </b-table>
                             <!-- Ticket suministro -->
                            <b-modal size="sm" v-model="ticketImpresion">
                                <template slot="modal-header">
                                    <div class="text-center">
                                        <!-- Impresion de Ticket Suministro -->
                                    </div>
                                </template>
                                <print-ticket-suministro :dataitem="datosTicketSuministro" :printTicket="printTicket" ></print-ticket-suministro>
                                <template slot="modal-footer">   
                                    <b-button size="sm" variant="primary" @click="imprimirTicket()"><i class="fas fa-print"></i> Imprimir</b-button>
                                    <b-button size="sm" variant="" @click="cerrarTicket()">Cerrar</b-button>
                                </template>
                            </b-modal>
                            <b-row>
                            <b-col cols="9" sm="7" md="6" lg="6" xl="6">
                                <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
                            </b-col>
                            <b-col cols="9" sm="7" md="6" lg="6" xl="6">
                                <div class="float-right">
                                <b-pagination
                                    :total-rows="total"
                                    v-model="paginaActual"
                                    @input="listarTicket"
                                    :per-page="limite"
                                ></b-pagination>
                                </div>
                            </b-col>
                        </b-row>
                        </template>
                    </b-col>
                </b-row>
        </b-card>
    </div>
</template>
<script>
import { DocumentosIdentidadPersona } from '@/shared/utils'
import Datepicker from 'vuejs-datepicker'
import {es} from 'vuejs-datepicker/dist/locale'
import axios from 'axios'
import { TipoMoneda } from '@/shared/utils'
import PrintTicketSuministro from '@/components/comunes/PrintTicketSuministro'
import { FormaPag } from "@/shared/utils";
export default {
    name:'ticketSuministro',
    components:{
        Datepicker,
        PrintTicketSuministro
    },
    data() {
        return {
            listaRemitentes: [],
            listaRemitente:false,
            numDocumento:"",
            tipoDocumento:6,
            documentoIdentidad:DocumentosIdentidadPersona,
            es:es,
            verModalTicket:false,
            listaVehiculos:[],
            listaVehiculo:false,
            iDvehiculo:'',
            iDconductor:'',
            listaConductores:[],
            listaConductor:false,
            fechaRegistro:'',
            descripcion:'',
            listProductos:[],
            listades:false,
            cantidadProducto:1,
            precioUnitario:'',
            precioTotal:'',
            observaciones:'',
            moneda: {
                  id: '1',
                  codigo: 'PEN',
                  descripcion: 'SOLES',
                  simbolo: 'S/.'
              },
            tipoMoneda: TipoMoneda,
            idProducto:'',
            placa:'',
            nomConductor:'',
            paginaActual: 1,
            limite:12,
            total: 0.0,
            desde: 0.0,
            hasta: 0.0,
            mostrarTabla: true,
            ticketsLista:[],
            ticketsLista_lista:[
                {key:"serie", label:"Serie-Número"},
                {key:"fechaRegistro", label:"Fecha Registro"},
                {key:"placa", label:"Placa"},
                {key:"nombreProducto", label:"Producto"},
                {key:"cantidadProducto", label:"Cantidad"},
                {key:"precioUnitario", label:"Precio Unitario"},
                {key:"PrecioTotal", label:"Precio Total"},
                {key:"moneda", label:"Moneda"},
                {key:"observaciones", label:"Observación"},
                {key:"username", label:"Usuario"},
                {key:"estado", label:"Estado"},
                {key:"acciones", label:"Acciones"},
            ],
            botonEditar:false,
            idTicket:'',
            listaSeries: [],
            serieInicial:0,
            cadenabusqueda:'',
            datosTicketSuministro:{},
            ticketImpresion:false,
            printTicket:false,
            formadepago: {
                codigo: '008',
                nombre: "Efectivo ventas menores"
            },
            formaPago: FormaPag,
            
        }
    },
    mounted() {
        this.customFormatter();
        this.listarTicket();
        this.getSeries();
    },
    watch:{
        precioUnitario(){
            if(this.precioUnitario > 0 ){
                this.precioTotal =  this.cantidadProducto * this.precioUnitario
            }else{
                this.precioTotal = ''
            }
        },
        cantidadProducto(){
          if(this.cantidadProducto > 0 ){
                this.precioTotal =  this.cantidadProducto * this.precioUnitario
            }else{
                this.precioTotal = ''
            }  
        }
    },
    methods: {
        modalTicket(){
            this.verModalTicket = true;
            this.limpiarDatos();
        },
        listaDeVehiculos(){  
            axios.post(process.env.VUE_APP_API_URL + "vehiculos/listar",{
                token:this.$store.getters.userToken,
            })
            .then(response =>(
                this.listaVehiculos = response.data.data,
                this.listaVehiculo = true
            ))
            .catch(error=>(
                console.log('ERROR LISTAR VEHICULOS',error.response.data)
            ))
        },
        closeListVehiculo(){
            this.listaVehiculo = false;
        },
        setReceiverVehiculo(item){
            this.placa = item.placa
            this.iDvehiculo = item.idVehiculo,
            this.listaVehiculo = false;
        },
        setReceiverConductor(item){
            this.nomConductor = item.nombres
            this.iDconductor = item.idConductor,
            this.listaConductor = false;
        },
        listarConductores(){
            axios
            .post(process.env.VUE_APP_API_URL + 'conductor/listar',{
                token: this.$store.getters.userToken,
                page: this.paginaActual,
                limit: this.limite,
                order:"desc"
            })
            .then(response => (
                this.listaConductores = response.data.data,
                this.listaConductor = true,
                this.total = response.data.total,
                this.desde = response.data.from,
                this.hasta = response.data.to                
            ))
            .catch(function (error){
                this.listaConductor = false,
                console.log(error)
            }) 
        },
        closeListConductor(){
            this.listaConductor = false;
        },
        customFormatter(date) {
            this.fechaRegistro = this.$moment(date).format('YYYY-MM-DD HH:mm:ss');
            return this.$moment(date).format('YYYY-MM-DD HH:mm:ss');
        },
        searchDescripcion(){
            if(this.descripcion.length > 2){
                this.listades = true,
                axios
                .post(process.env.VUE_APP_API_URL + 'productos/buscar',{
                    token: this.$store.getters.userToken,
                    filtro: 'name',
                    p: this.descripcion
                })
                .then(response=>(
                    this.listProductos = response.data.response
                ))
                .catch(error=>(
                console.log(error)
                ))
            }       
        },
        cerraListaProductos(){
            this.listades = false;
        },
        setReceiverDescription: function (item) {
            this.idProducto = item.idProducto,
            this.descripcion = item.descripcion,
            this.precioUnitario = item.precioUnitario
            this.listades = false,
            this.listProductos = []
        },
        validar(){
            if(this.placa !='' &&
                this.nomConductor !='' &&
                this.descripcion !='' &&
                this.cantidadProducto !='' &&
                this.precioUnitario !='' &&
                this.precioTotal !=''){
                    return false
            }else{
                return true
            }
        },
        enviarTicket(){
            let enviarTicket = {}
            enviarTicket.token = this.$store.getters.userToken,
            enviarTicket.idConductor = this.iDconductor,
            enviarTicket.idVehiculo = this.iDvehiculo,
            enviarTicket.fechaRegistro = this.fechaRegistro
            enviarTicket.idUsuario = this.$store.getters.userData.idUsuario
            if(this.serieInicial == 0){
                 enviarTicket.serieTicket = this.listaSeries[0]
            }else{
                  enviarTicket.serieTicket = this.listaSeries[this.serieInicial]
            }   
            enviarTicket.idProducto = this.idProducto
            enviarTicket.moneda = this.moneda.descripcion
            enviarTicket.cantidadProducto = this.cantidadProducto
            enviarTicket.nombreProducto = this.descripcion
            enviarTicket.precioUnitario = this.precioUnitario
            enviarTicket.PrecioTotal = this.precioTotal
            enviarTicket.estado = 1
            enviarTicket.tipoDocumento = this.tipoDocumento
            enviarTicket.numeroDocumento = this.numDocumento
            enviarTicket.formaPago = this.formadepago.codigo //Efectivo
            enviarTicket.observaciones = this.observaciones

            axios
            .post(process.env.VUE_APP_API_URL+'ticket/crear',enviarTicket)
            .then(response =>(
                this.$snotify.success(response.data.msg, 'Éxito'),
                this.verModalTicket = false,
                this.listarTicket(),
                this.limpiarDatos() 
            ))
            .catch(error=>(
                this.$snotify.danger(error.data.msg, 'Error')
            ))
        },
        limpiarDatos(){
            this.placa = '',
            this.nomConductor = '',
            this.iDconductor = '',
            this.iDvehiculo = '',
            this.idProducto = '',
            this.cantidadProducto = 1,
            this.descripcion = '',
            this.precioUnitario = '',
            this.precioTotal = '',
            this.observaciones = ''
            this.botonEditar = false
        },
        listarTicket(){
            this.mostrarTabla = true;
            axios
            .post(process.env.VUE_APP_API_URL + 'ticket/listar',{
                token:this.$store.getters.userToken,
                page: this.paginaActual,
                limit: this.limite,
                order:"desc"
            })
            .then(response =>(
                this.ticketsLista = response.data.data,
                this.mostrarTabla = false,
                this.total = response.data.total,
                this.desde = response.data.from,
                this.hasta = response.data.to
            ))
            .catch(error=>(
                console.log('ERROR LISTADO',error.response.data)
            ))
        },
        editarTicket(item){
            this.verModalTicket = true;
            this.placa = item.vehiculo.placa
            this.iDvehiculo = item.vehiculo.idVehiculo
            this.nomConductor = item.conductor.nombres
            this.iDconductor = item.conductor.idConductor
            this.fechaRegistro = item.fechaRegistro
            this.descripcion = item.nombreProducto
            this.idProducto = item.idProducto
            this.idUsuario = item.idUsuario
            this.idTicket = item.idTicket
            this.cantidadProducto = item.cantidadProducto
            this.precioUnitario = item.precioUnitario
            this.precioTotal = item.PrecioTotal
            this.observaciones = item.observaciones
            this.botonEditar = true;
        },
        enviarEdicion(){
            let nuevaInfo ={}
            nuevaInfo.token = this.$store.getters.userToken,
            nuevaInfo.idVehiculo = this.iDvehiculo,
            nuevaInfo.idConductor = this.iDconductor, 
            nuevaInfo.idTicket = this.idTicket,
            nuevaInfo.fechaRegistro = this.fechaRegistro,
            nuevaInfo.idUsuario = this.idUsuario,
            nuevaInfo.idProducto = this.idProducto,
            nuevaInfo.moneda = this.moneda.descripcion,
            nuevaInfo.cantidadProducto = this.cantidadProducto,
            nuevaInfo.nombreProducto = this.descripcion,
            nuevaInfo.precioUnitario = this.precioUnitario,
            nuevaInfo.precioTotal = this.precioTotal,
            nuevaInfo.estado = 1,
            nuevaInfo.observaciones = this.observaciones
          axios
            .post(process.env.VUE_APP_API_URL + 'ticket/actualizar',nuevaInfo)
            .then(response =>(
                this.$snotify.success(response.data.msg, "Exito"),
                this.verModalTicket = false,
                this.botonEditar = false,
                this.listarTicket()
            ))
            .catch(error=>(
                this.$snotify.danger(error.response.data.msg, "Error")
            ))  
        },
        getSeries: function () {
            axios
            .post(process.env.VUE_APP_API_URL + 'usuario/series/14', {
                token: this.$store.getters.userToken
            })
            .then(response => (
                this.listaSeries = response.data.data
                ))
            .catch(error => {
                console.log('Error de Series =>',error)
            })
        },
        eliminarTicket(item){
          this.$swal({
            title: 'Eliminar Ticket',
            text: '¿Seguro que desea eliminar el Ticket?',
            icon: 'warning',
            buttons: true,
            dangerMode: true
            }).then((willDelete) => {
            if(willDelete){
                axios.post(process.env.VUE_APP_API_URL + "ticket/eliminar",{
                    token: this.$store.getters.userToken,
                    idTicket: item.idTicket
                })
                .then(response =>(
                    this.$snotify.success(response.data.msg, "Exito"),
                    this.listarTicket()
                ))
                .catch(error=>(
                     this.$snotify.danger(error.response.data.msg, "Error")
                )) 
            }
            })       
        },
         searchProduct: function () {
            let item
            let captura
            if(this.cadenabusqueda != ''){
                axios
            .post(process.env.VUE_APP_API_URL + 'ticket/buscar', {
                token: this.$store.getters.userToken,
                p: this.cadenabusqueda
            })
            .then(response => (
               item = response.data[0],
               captura.push(item),
               this.listarTicket = captura
                ))
            .catch(error => {
                 this.$snotify.danger(error.response.data.msg, "Error")
            })
            }else{
                this.$snotify.warning("Debe ingresar un valor en la Búsqueda")
            }
        },
        openModal(item){
            console.log(item)
            this.datosTicketSuministro = item
            this.ticketImpresion = true;
        },
        imprimirTicket(){
            this.printTicket = true
        },
        cerrarTicket(){
            this.ticketImpresion = false;
            this.printTicket = false
        },
        convertirCredito(value){
            axios
            .post(process.env.VUE_APP_API_URL + 'documentoscredito/ticket/convertirdoc',{
                token: this.$store.getters.userToken,
                iddocumento:value.idTicket
            })
            .then(response => (
               this.$snotify.success(response.data.msg, "Exito")
                ))
            .catch(error => {
                 this.$snotify.danger(error.response.data.msg, "Error")
            })
        },
        getReceiversRemitente: function () {
            axios
            .post(process.env.VUE_APP_API_URL + 'receptores/listaconterceros',{
                token: this.$store.getters.userToken,
                q: this.numDocumento,
                tipoRec: this.tipoDocumento 
            })
            .then(response => (
                this.listaRemitentes = response.data,
                this.listaRemitente = true                         
            ))
            .catch(function (error){
                this.listaRemitente = false
            })                 
        },
        setReceiverRemitente: function (item) {
            this.numDocumento = item.idReceptor
            this.listaRemitente = false;
        },
    },
}
</script>
<style scoped>
.searcher-fieldplaca{
        z-index: 1000;
        position: absolute;
        max-height: 200px !important;
        overflow-y: scroll;
        width: 650px;
    }
.searcher-result3{
        background-color: #77AEC1;
    }
.searcher-result2 {
        background-color: white;
        font-size: 1em;
        cursor: pointer;
    }
.searcher-result2 :hover{
        background-color: #DAF1F9;
        border:1px solid grey
    }
.tablaborde{
        border: 1px solid #B8cdd5;
    }
.searcher-fieldconductor{
        z-index: 1000;
        position: absolute;
        max-height: 200px !important;
        overflow-y: scroll;
        width: 720px;
    }
</style>